import {api} from '~/CreateFabricInvitation/api/api';

const cartApi = api.injectEndpoints({
  endpoints: (builder) => ({
    getPackages: builder.query({
      query: (eventId) => ({
        url: `/ajax/cart/packages/${eventId}`,
        method: 'GET',
      }),
      providesTags: ['Packages'],
    }),
    updateCart: builder.mutation({
      queryFn: async ({eventId, data}, {dispatch}, opts, baseQuery) => {
        const cart = await baseQuery({
          url: `/ajax/cart/${eventId}`,
          method: 'POST',
          body: data,
        });
        dispatch(
          cartApi.util.updateQueryData('getCart', eventId, (draft) => ({...draft, ...cart.data}))
        );
        return cart;
      },
      providesTags: ['Cart'],
    }),
    getCart: builder.query({
      query: (eventId) => ({
        url: `/ajax/cart/${eventId}`,
      }),
      providesTags: ['Cart'],
    }),
    setDiscount: builder.mutation({
      queryFn: async ({eventId, data}, {dispatch}, opts, baseQuery) => {
        const cart = await baseQuery({
          url: `/ajax/cart/discounts/${eventId}`,
          method: 'POST',
          body: data,
        });
        dispatch(
          api.util.updateQueryData('getCart', eventId, (draft) => ({...draft, ...cart.data}))
        );
        return cart;
      },
      async onQueryStarted({eventId, data}, {dispatch, queryFulfilled}) {
        // use optimistic updates to immediately set the coupon code
        const patchResult = dispatch(
          api.util.updateQueryData('getCart', eventId, (draft) => ({
            ...draft,
            ...{discountLoading: true, discountCode: data.code},
          }))
        );
        try {
          await queryFulfilled;
        } catch {
          patchResult.undo();
        }
        dispatch(
          api.util.updateQueryData('getCart', eventId, (draft) => ({
            ...draft,
            ...{discountLoading: false},
          }))
        );
      },
      providesTags: ['Cart'],
    }),
    deleteDiscount: builder.mutation({
      queryFn: async ({eventId, data}, {dispatch}, opts, baseQuery) => {
        const cart = await baseQuery({
          url: `/ajax/cart/discounts/${eventId}`,
          method: 'DELETE',
          body: data,
        });
        dispatch(
          api.util.updateQueryData('getCart', eventId, (draft) => ({...draft, ...cart.data}))
        );
        return cart;
      },
      async onQueryStarted(eventId, {dispatch, queryFulfilled}) {
        // use optimistic updates to immediately remove the coupon code
        const patchResult = dispatch(
          api.util.updateQueryData('getCart', eventId, (draft) => ({
            ...draft,
            ...{discountLoading: true, discountCode: undefined},
          }))
        );
        try {
          await queryFulfilled;
        } catch {
          patchResult.undo();
        }
        dispatch(
          api.util.updateQueryData('getCart', eventId, (draft) => ({
            ...draft,
            ...{discountLoading: false},
          }))
        );
      },
      providesTags: ['Cart'],
    }),
    checkout: builder.mutation({
      query: ({eventId, data: {paymentType, paymentData, packageId, useSavedCard, total}}) => ({
        url: `/ajax/cart/checkout/${eventId}`,
        method: 'POST',
        body: {
          paymentType,
          paymentData,
          packageId,
          useSavedCard,
          total,
        },
      }),
    }),
  }),
});

export const {
  useGetCartQuery,
  useLazyGetCartQuery,
  useGetPackagesQuery,
  useLazyGetPackagesQuery,
  useSetDiscountMutation,
  useDeleteDiscountMutation,
  useUpdateCartMutation,
  useCheckoutMutation,
} = cartApi;
